import React from 'react';
import { Folder, Upload, Download, Search, Share2, Lock, AlertCircle, Clock } from 'lucide-react';

const DocumentsPage: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Documents</h1>
        <p className="text-gray-600">Document management and storage</p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="flex items-start gap-4">
          <AlertCircle className="h-6 w-6 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-blue-900 mb-2">Coming Soon</h2>
            <p className="text-blue-800 mb-4">
              The Documents module is currently under development. Soon you'll be able to:
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Upload className="h-5 w-5 text-blue-700" />
                  <h3 className="font-medium text-blue-900">Upload & Store</h3>
                </div>
                <p className="text-sm text-blue-700">
                  Upload, store, and organize all your important documents in one secure location
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Folder className="h-5 w-5 text-blue-700" />
                  <h3 className="font-medium text-blue-900">Smart Organization</h3>
                </div>
                <p className="text-sm text-blue-700">
                  Organize documents with folders, tags, and categories for easy retrieval
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Search className="h-5 w-5 text-blue-700" />
                  <h3 className="font-medium text-blue-900">Advanced Search</h3>
                </div>
                <p className="text-sm text-blue-700">
                  Find documents quickly with full-text search and smart filters
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Share2 className="h-5 w-5 text-blue-700" />
                  <h3 className="font-medium text-blue-900">Secure Sharing</h3>
                </div>
                <p className="text-sm text-blue-700">
                  Share documents securely with team members and external collaborators
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Lock className="h-5 w-5 text-blue-700" />
                  <h3 className="font-medium text-blue-900">Access Control</h3>
                </div>
                <p className="text-sm text-blue-700">
                  Set granular permissions to control who can view, edit, or delete documents
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Download className="h-5 w-5 text-blue-700" />
                  <h3 className="font-medium text-blue-900">Bulk Operations</h3>
                </div>
                <p className="text-sm text-blue-700">
                  Download multiple documents at once and perform bulk actions efficiently
                </p>
              </div>
            </div>

            <div className="mt-6 flex items-center gap-2 text-sm text-blue-700">
              <Clock className="h-4 w-4" />
              <span>Expected release: Q2 2024</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsPage;